import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRbSystemAlert } from '@scmlatam/web-ui';
import { serviceSchedule } from '../services/service';
import type { Options } from '../types/hooks';
import { usePermisoSchedule } from '../../../../auth/permisosModulos';

interface UseDeleteShiftProps {
    shiftAssignId: string | null;
    reload: () => Promise<void> | void;
    option: Options | null;
    setOption: (value: Options | null) => void;
}

export const useDeleteShift = ({ shiftAssignId, reload, option, setOption }: UseDeleteShiftProps) => {
    const { t } = useTranslation('schedule.form.delete_shift');
    const { showAlert } = useRbSystemAlert();
    const canDeleteShift = usePermisoSchedule('delete_shift');
    const [openForm, setOpenForm] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (option === 'delete_shift' && shiftAssignId) {
            if (canDeleteShift) setOpenForm(true);
            setOption(null);
        }
    }, [option, shiftAssignId, setOption, canDeleteShift]);

    const closeForm = () => {
        setOpenForm(false);
    };

    const submit = async () => {
        if (!shiftAssignId || !canDeleteShift) return;

        setLoading(true);

        try {
            const ok = await serviceSchedule.deleteShift({
                shiftId: parseInt(shiftAssignId, 10),
                alert: { t, showAlert },
            });

            if (ok) {
                await reload();
                closeForm();
            }
        } finally {
            setLoading(false);
        }
    };
    return {
        t,
        title: t('delete_shift.title'),
        openForm,
        setOpenForm,
        closeForm,
        loading,
        submit,
    };
};
